import { Node_Type } from 'ricos-schema';
export const buildSingleNode = (node, updatesForNode) => {
  var _node$galleryData;
  switch (node.type) {
    case Node_Type.IMAGE:
      const {
        alt
      } = updatesForNode[0];
      return {
        ...node,
        imageData: {
          ...node.imageData,
          altText: alt
        }
      };
    case Node_Type.GALLERY:
      const altMap = Object.fromEntries(updatesForNode.map(u => [u.imageId, u.alt]));
      const originalGalleryItems = ((_node$galleryData = node.galleryData) == null ? void 0 : _node$galleryData.items) ?? [];
      return {
        ...node,
        galleryData: {
          ...node.galleryData,
          items: originalGalleryItems.map(item => {
            var _item$image;
            const mediaId = (_item$image = item.image) == null || (_item$image = _item$image.media) == null || (_item$image = _item$image.src) == null ? void 0 : _item$image.url;
            return {
              ...item,
              altText: (mediaId && altMap[mediaId]) ?? item.altText
            };
          })
        }
      };
    default:
      return node;
  }
};
//# sourceMappingURL=build-single-rich-content-node.js.map